<template>
  <a-form ref="formRef" :model="dataForm">
    <dc-layout-card title="基础信息" :span="6">
      <dc-form-item label="辅导人" name="mentor" :rules="[{ required: true, message: '请输入' }]">
        <UserSelect
          permission
          :disabled="true"
          v-model:value="dataForm.mentor"
          defaultValue="me"
          @change="handleMentorChange"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="辅导人区域">
        <CustomerAreaCascader appId="cos_lbu" v-model:value="dataForm.mentorRegion" :disabled="true" :view="view" />
      </dc-form-item>
      <dc-form-item label="本次辅导时间" :rules="[{ required: true, message: '请选择' }]">
        <CosSingleDateTimePicker
          v-model:startTime="dataForm.tutoringTime"
          defaultValue="now"
          :isRange="false"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="下次辅导时间" name="nextTutoringTime" :rules="[{ required: true, message: '请输入' }]">
        <CosSingleDateTimePicker v-model:startTime="dataForm.nextTutoringTime" :isRange="false" :view="view" />
      </dc-form-item>
      <dc-form-item label="被辅导人" name="trainee" :rules="[{ required: true, message: '请输入' }]">
        <UserSelect permission v-model:value="dataForm.trainee" @change="handleTraineeChange" :view="view" />
      </dc-form-item>
      <dc-form-item label="被辅导人区域">
        <CustomerAreaCascader appId="cos_lbu" v-model:value="dataForm.traineeRegion" :disabled="true" :view="view" />
      </dc-form-item>
      <dc-form-item label="重点关注指标">
        <CosInput v-model:value="dataForm.focusArea" :maxlength="200" placeholder="请输入" :view="view" />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card title="关注指标和项目" :span="6">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleIndicatorInfoAdd()">新增</a-button>
      </template>
      <MultipleItem :view="view">
        <template v-for="(item, index) in dataForm.indicatorInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '指标和项目'"
            :class="index ? 'no-form-label' : ''"
            :name="['indicatorInfo', index, 'indicatorsAndProjects']"
            :rules="{ required: true, message: '请输入' }"
          >
            <CosInput v-model:value="item.indicatorsAndProjects" :maxlength="200" placeholder="请输入" :view="view" />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '当前进度状态详情'"
            :class="index ? 'no-form-label' : ''"
            :name="['indicatorInfo', index, 'progressStatus']"
            :rules="{ required: true, message: '请输入' }"
          >
            <div class="flex">
              <CosInput v-model:value="item.progressStatus" :maxlength="200" placeholder="请输入" :view="view" />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.indicatorInfo && dataForm.indicatorInfo.length > 1"
                @click="handleIndicatorInfoDel(index)"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="行动计划" :span="6">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleActionPlanInfoAdd()">新增</a-button>
      </template>
      <MultipleItem :view="view">
        <template v-for="(item, index) in dataForm.actionPlanInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '设定目标和截止时间'"
            :class="index ? 'no-form-label' : ''"
            :name="['actionPlanInfo', index, 'settingGoals']"
            :rules="{ required: true, message: '请输入' }"
          >
            <CosInput v-model:value="item.settingGoals" :maxlength="200" placeholder="请输入" :view="view" />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '行动方案'"
            :class="index ? 'no-form-label' : ''"
            :name="['actionPlanInfo', index, 'actionPlan']"
            :rules="{ required: true, message: '请输入' }"
          >
            <CosInput v-model:value="item.actionPlan" :maxlength="200" placeholder="请输入" :view="view" />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '目标客户'"
            :class="index ? 'no-form-label' : ''"
            :name="['actionPlanInfo', index, 'targetCustomer']"
            :rules="{ required: true, message: '请输入' }"
          >
            <div class="flex">
              <CosInput v-model:value="item.targetCustomer" :maxlength="200" placeholder="请输入" :view="view" />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.actionPlanInfo && dataForm.actionPlanInfo.length > 1"
                @click="handleActionPlanInfoDel(index)"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="6" />
        </template>
      </MultipleItem>

      <dc-form-item label="附件上传" name="fileId" :span="24">
        <UploadFile v-model:value="dataForm.fileId" valueType="array" :view="view" />
      </dc-form-item>
      <dc-form-item :span="24" label="备注">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.remark" :view="view" />
      </dc-form-item>
      <dc-form-item label="抄送人" name="ccTo">
        <UserSelect permission v-model:value="dataForm.ccTo" mode="multiple" :view="view" />
      </dc-form-item>
    </dc-layout-card>

    <!-- <dc-layout-card title="当前进度状态" :span="6">
      <dc-form-item :span="12" label="指标数据" name="indicatorData" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.indicatorData" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="进度和行为活动" name="process" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.process" :view="view" />
      </dc-form-item>
      <dc-form-item label="附件上传" name="fileId" :span="24">
        <UploadFile v-model:value="dataForm.fileId" valueType="array" :view="view" />
      </dc-form-item>
    </dc-layout-card> -->

    <!-- <dc-layout-card title="行动计划" :span="6">
      <dc-form-item :span="12" label="行动方案" name="actionPlan" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.actionPlan" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="目标设定" name="target" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.target" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="目标客户">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.targetCustomer" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="备注">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.remark" :view="view" />
      </dc-form-item>
      <dc-form-item label="抄送人" name="ccTo">
        <UserSelect permission v-model:value="dataForm.ccTo" mode="multiple" :view="view" />
      </dc-form-item>
    </dc-layout-card> -->

    <dc-layout-card
      title="回顾"
      :span="6"
      v-if="props.type === 'review' || dataForm.reviewInfo != undefined"
    >
      <template #subTitle>
        <a-button type="primary" v-if="!((view && props.type === 'comment') || props.type === 'view')" ghost @click="handleReviewAdd()">新增</a-button>
      </template>
      <dc-form-item label="回顾时间" name="reviewTime" :rules="[{ required: true, message: '请输入' }]">
        <!-- <CosSingleDateTimePicker v-model:startTime="dataForm.reviewTime" defaultValue="now" :disabled="true" :isRange="false"  /> -->
        <CosSingleDateTimePicker
          defaultValue="now"
          v-model:startTime="dataForm.reviewTime"
          :disabled="true"
          :isRange="false"
          :view="(view && props.type === 'comment') || props.type === 'view'"
        />
      </dc-form-item>
      <!-- <dc-form-item :span="12" label="行动结果" name="actionResult" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea
          :maxlength="2000"
          placeholder="请输入"
          v-model:value="dataForm.actionResult"
          :view="(view && props.type === 'comment') || props.type === 'view'"
        />
      </dc-form-item>

      <dc-form-item :span="12" label="执行结果" name="executionResult" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea
          :maxlength="2000"
          placeholder="请输入"
          v-model:value="dataForm.executionResult"
          :view="(view && props.type === 'comment') || props.type === 'view'"
        />
      </dc-form-item> -->

      <MultipleItem :view="(view && props.type === 'comment') || props.type === 'view'">
        <template v-for="(item, index) in dataForm.reviewInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '行动方案'"
            :class="index ? 'no-form-label' : ''"
            :name="['reviewInfo', index, 'actionPlan']"
            :rules="{ required: true, message: '请输入' }"
          >
            <CosInput v-model:value="item.actionPlan" :maxlength="200" placeholder="请输入" :view="(view && props.type === 'comment') || props.type === 'view'"/>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '行动结果'"
            :class="index ? 'no-form-label' : ''"
            :name="['reviewInfo', index, 'actionResults']"
            :rules="{ required: true, message: '请输入' }"
          >
            <div class="flex">
              <CosInput v-model:value="item.actionResults" :maxlength="200" placeholder="请输入" :view="(view && props.type === 'comment') || props.type === 'view'"/>
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="!((view && props.type === 'comment') || props.type === 'view') && dataForm.reviewInfo && dataForm.reviewInfo.length > 1"
                @click="handleReviewDel(index)"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
  </a-form>

  <cos-footer-button v-model:value="dataForm" :formRef="formRef">
    <a-button
      type="primary"
      v-if="props.type === 'add' || props.type === 'edit' || props.type === 'review'"
      @click="handleSubmit()"
      :loading="loading"
      v-permission="permissionPage.save"
      >保存</a-button
    >
    <a-button
      type="primary"
      v-if="props.type === 'view' && dataForm.status !== 2"
      @click="editRow"
      v-permission="'lbu_sale_coaching_edit_btn'"
    >
      编辑
    </a-button>
    <a-button
      v-if="props.type === 'view' && dataForm.status !== 2"
      @click="confirmRow"
      v-permission="'lbu_sale_coaching_confirm_btn'"
    >
      确认
    </a-button>
    <a-button
      v-if="
        props.type === 'view' &&
        dataForm.status === 2 &&
        !dataForm.actionResult &&
        shareInfo.getUserInfo().work_code === dataForm.mentor
      "
      @click="reviewRow"
      v-permission="'lbu_sale_coaching_review_btn'"
    >
      回顾
    </a-button>
    <a-button
      v-if="props.type === 'view' && dataForm.status === 2"
      @click="commentRow"
      v-permission="'lbu_sale_coaching_comment_btn'"
    >
      评论
    </a-button>
  </cos-footer-button>
</template>

<script setup lang="ts">
import { shareInfo } from '@dc-platform/dc-interaction'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import type { FormInstance } from 'ant-design-vue'
import { ref, computed, onMounted } from 'vue'
import UploadFile from '@/components/UploadFile'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { fetchUsersByWorkCode } from '@/api/common'
import type { LbuSaleCoachingEditParams } from '@/typings/api/saleCoaching'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'

import {
  saleCoachingCreate,
  saleCoachingDetail,
  saleCoachingUpdate,
  saleCoachingReview,
  saleCoachingConfirm
} from '@/api/yuntuSales/saleCoaching'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()

const dataForm = ref<LbuSaleCoachingEditParams>({})
const formRef = ref<FormInstance>()
const loading = ref(false)
const route = useRoute()
const props = defineProps({
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  view: {
    type: Boolean
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'comment', 'review', 'view'].includes(value)
    }
  }
})

onMounted(() => {
  fetch()

  if (props.type === 'add') {
    if (dataForm.value.indicatorInfo === undefined) {
      dataForm.value.indicatorInfo = [{}]
    }

    if (dataForm.value.actionPlanInfo === undefined) {
      dataForm.value.actionPlanInfo = [{}]
    }
  }
})

const permissionPage = computed(() => {
  if (props.type === 'add') {
    return { save: 'lbu_sale_coaching_add_btn' }
  } else if (props.type === 'edit') {
    return { save: 'lbu_sale_coaching_edit_btn' }
  } else if (props.type === 'review') {
    return { save: 'lbu_sale_coaching_review_btn' }
  } else {
    return {}
  }
})

const handleIndicatorInfoAdd = () => {
  dataForm.value.indicatorInfo?.push({})
}
const handleIndicatorInfoDel = (index: number) => {
  dataForm.value.indicatorInfo?.splice(index, 1)
}

const handleActionPlanInfoAdd = () => {
  dataForm.value.actionPlanInfo?.push({})
}
const handleActionPlanInfoDel = (index: number) => {
  dataForm.value.actionPlanInfo?.splice(index, 1)
}

const handleReviewAdd = () => {
  dataForm.value.reviewInfo?.push({})
}
const handleReviewDel = (index: number) => {
  dataForm.value.reviewInfo?.splice(index, 1)
}

const emit = defineEmits(['update:detail', 'getDetail'])
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    saleCoachingDetail({ id: route.query.id })
      .then((res) => {
        if (props.type === 'review') {
          if (!res.data.reviewTime) {
            res.data.reviewTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
          }

          if (!res.data.reviewInfo) {
            res.data.reviewInfo = res.data.actionPlanInfo?.length ? res.data.actionPlanInfo?.map((item) => ({
              actionPlan: item.actionPlan
            })) : [{}]
          }
        }

        dataForm.value = res.data ? res.data : {}

        emit('getDetail', res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}

const handleMentorChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const handleTraineeChange = (val: any) => {
  if (val && props.type === 'add') {
    const employeeList = [val]
    fetchUsersByWorkCode({ employeeList }).then((res) => {
      const [followerInfo] = res.data
      if (followerInfo && followerInfo.lbuCustomerRegion != null) {
        dataForm.value.traineeRegion = followerInfo.lbuCustomerRegion
      } else {
        dataForm.value.traineeRegion = undefined
        setTimeout(() => formRef.value?.clearValidate('traineeRegion'))
      }
    })
  }
}

const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.lbuCustomerRegion != null) {
      dataForm.value.mentorRegion = followerInfo.lbuCustomerRegion
    } else {
      dataForm.value.mentorRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('mentorRegion'))
    }

    if (followerInfo && followerInfo.managerNo != null) {
      dataForm.value.ccTo = [`${followerInfo.managerNo}`]
    }
  })
}

const confirmRow = () => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      saleCoachingConfirm({ id: route.query.id }).then(() => {
        DcMessage.success('操作成功')
        goBack()
      })
    }
  })
}

const reviewRow = () => {
  router.push({
    path: '/lbu/saleCoaching/review',
    query: {
      id: route.query.id
    }
  })
}

const commentRow = () => {
  router.push({
    path: '/lbu/saleCoaching/comment',
    query: {
      id: route.query.id
    }
  })
}

const editRow = () => {
  router.push({
    path: '/lbu/saleCoaching/edit',
    query: {
      id: route.query.id
    }
  })
}

const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...dataForm.value
    }
    try {
      if (props.type === 'edit') {
        await saleCoachingUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await saleCoachingCreate(p)
        DcMessage.success('新增成功')
      } else if (props.type === 'review') {
        await saleCoachingReview(p)
        DcMessage.success('回顾成功')
      }
      goBack()
    } catch (error) {}
    loading.value = false
  })
}
</script>
